/** tm/legal/PcNotifyToggle.tsx — 「PC 알림 받기」 (이 브라우저만). 켤 때만 권한을 묻고, 거부됐으면 방법을 안내한다 */
import { useState } from 'react';
import { C, T } from '../components/ui';
import { MUTED } from './legalTheme';
import { getPcNotify, setPcNotify, pcPermission, pcSupported } from './alertPrefs';

interface Props { compact?: boolean; onToast?: (m: string, k?: 'ok' | 'error') => void }

export default function PcNotifyToggle({ compact, onToast }: Props) {
  const [on, setOn] = useState(() => getPcNotify() && pcPermission() === 'granted');
  const [perm, setPerm] = useState(pcPermission);
  if (!pcSupported()) return compact ? null : <p style={{ fontSize: T.sm, color: MUTED, margin: 0 }}>이 브라우저는 PC 알림을 지원하지 않습니다.</p>;

  const toggle = async (next: boolean) => {
    if (!next) { setPcNotify(false); setOn(false); onToast?.('PC 알림을 껐습니다'); return; }
    let p = Notification.permission;
    if (p === 'default') { try { p = await Notification.requestPermission(); } catch { p = 'denied'; } }
    setPerm(p);
    if (p !== 'granted') { setPcNotify(false); setOn(false); onToast?.('브라우저에서 알림이 막혀 있습니다. 주소창 왼쪽 자물쇠에서 알림을 허용해 주세요', 'error'); return; }
    setPcNotify(true); setOn(true); onToast?.('PC 알림을 켰습니다. 다른 창을 보고 있을 때 새 소식을 알려 드립니다');
  };

  return (
    <label style={{ display: 'flex', gap: compact ? 6 : 10, alignItems: compact ? 'center' : 'flex-start', cursor: 'pointer', fontSize: compact ? T.xs : T.md, color: compact ? C.sub : C.text, minHeight: compact ? 32 : undefined }}>
      <input type="checkbox" checked={on} onChange={e => toggle(e.target.checked)} style={{ marginTop: compact ? 0 : 3 }} />
      <span>
        <b style={{ fontWeight: compact ? 500 : 600 }}>PC 알림 받기</b>
        {compact && <span style={{ color: MUTED }}> · 다른 창을 볼 때도</span>}
        {!compact && <span style={{ display: 'block', fontSize: T.sm, color: MUTED, marginTop: 2, lineHeight: 1.6 }}>
          다른 창을 보고 있을 때 새 소식이 오면 화면 구석에 알림을 띄웁니다. 이 PC의 이 브라우저에만 적용됩니다.
          {perm === 'denied' && <span style={{ color: C.red }}> 지금은 브라우저에서 알림이 막혀 있습니다.</span>}
        </span>}
      </span>
    </label>
  );
}
